import React, { useState } from "react";
import Controls from "../../components/FormsUI/index.js";
import { useAuth } from "../../utility/auth.js";
import EncryptionController from "../../controller/SuperAdmin/encryptionController.jsx";
import ExceptionHandlerController from "../../controller/ErrorLogsController.jsx";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import "../../css/style.css";
import { tokens } from "../../theme.js";
import CustomizedSnackbars from "../../components/Alert/index.js";
import {
  Grid,
  useTheme,
  Box,
  Container,
  Radio,
  FormControlLabel,
} from "@mui/material";
import { ENCRYPTION_TYPE, EncryptDecrypt } from "../../utility/encryption.js";
const INITIAL_FORM_STATE_ENCRYPTION = {
  tenantId: "",
  text: "",
  encryptionType: "",
};

const FORM_VALIDATION_ENCRYPTION = Yup.object().shape({
  tenantId: Yup.string()
    .matches(/^[0-9a-fA-F]{24}$/, "Enter valid Tenant ID")
    .required("Tenant ID is required"),
  text: Yup.string().required("Text is required"),
  encryptionType: Yup.boolean().required("Encryption Type is required"),
});

const INITIAL_FORM_STATE_HASH = { textToHash: "" };

const FORM_VALIDATION_HASH = Yup.object().shape({
  textToHash: Yup.string().required("Text is required"),
});
const ENCRYPTIONTYPE = { ENCRYPT: "encrypt", DECRYPT: "decrypt", HASH: "hash" };

const Encryption = () => {
  const encryptionController = new EncryptionController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const auth = useAuth();
  const [text, setText] = useState("");
  const [type, setType] = useState("");
  const [hashedText, setHashedText] = useState("");
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { token } = user;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const showAlert = (typeAlert, msgAlert) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = typeAlert;
    notify.msg = msgAlert;
    setAlert(notify);
  };

  const resetText = (typeResetValue) =>
    typeResetValue === ENCRYPTIONTYPE.ENCRYPT
      ? setText(() => "")
      : setHashedText(() => "");

  const getEncryptedDecryptedData = (data, encryptionValuetype) => {
    encryptionController
      .EncryptDecryptOrHashText(token, data)
      .then((result) => {
        const body = result?.data?.body;
        const hasData = Object.keys(body || {}).length !== 0;

        const decryptedData = hasData
          ? EncryptDecrypt(body, ENCRYPTION_TYPE?.DECRYPT)
          : body;

        if (result?.status === 200) {
          if (encryptionValuetype === ENCRYPTIONTYPE.ENCRYPT)
            setText(() => decryptedData?.text);
          else setHashedText(() => decryptedData?.text);
        }
        if (result?.status === 204) {
          showAlert("error", "No tenantId matches with entered Id.");
          resetText(type);
        } else if (result?.response?.status === 500) {
          showAlert("error", result?.response?.data?.message);
          resetText(type);
        }
      });
  };

  const getLabel = (encryptionType) => {
    if (encryptionType === "") {
      return "Text";
    }
    return encryptionType ? "Text to encrypt" : "Text to decrypt";
  };

  const getPlaceholder = (encryptionType) => {
    if (encryptionType === "") {
      return "Text";
    }
    return encryptionType ? "Text" : "9b5d543dc132418773e968043cd0060d";
  };

  const submit = (data, encrptDecryptType) => {
    let reqDto = {};
    if (encrptDecryptType === ENCRYPTIONTYPE.ENCRYPT) {
      setType(() =>
        data?.encryptionType ? ENCRYPTIONTYPE.ENCRYPT : ENCRYPTIONTYPE.DECRYPT
      );
      reqDto = {
        text: data?.text,
        type: data?.encryptionType
          ? ENCRYPTIONTYPE.ENCRYPT
          : ENCRYPTIONTYPE.DECRYPT,
        tenantId: data?.tenantId,
      };
    } else reqDto = { text: data?.textToHash, type: ENCRYPTIONTYPE.HASH };

    let caughtError;
    try {
      getEncryptedDecryptedData(reqDto, type);
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "SuperAdmin Encryption page submit method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };
  return (
    <>
      <Box
        sx={{
          "& .formBg": {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
          "& .MuiGrid-root.Mui-heading h2": {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Home</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>Encryption</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid item xs={12} className="formBg">
        <Container maxWidth="md" className="formClwidth">
          <div>
            <Formik
              enableReinitialize
              initialValues={{ ...INITIAL_FORM_STATE_ENCRYPTION }}
              validationSchema={FORM_VALIDATION_ENCRYPTION}
              onSubmit={(values) => submit(values, ENCRYPTIONTYPE.ENCRYPT)}
            >
              {({ values }) => (
                <Form>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                      <h4>Encrypt Decrypt Text :</h4>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controls.Textfield
                        name="tenantId"
                        label="Tenant ID"
                        type="string"
                        inputProps={{ maxLength: 24 }}
                        placeholder="64f6f8b40f6b434ef4b2e54e"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controls.Textfield
                        name="text"
                        label={getLabel(values?.encryptionType)}
                        type="string"
                        placeholder={getPlaceholder(values?.encryptionType)}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Controls.RadioButton name="encryptionType" row>
                        <Grid item xs={12} md={12}>
                          <h4>Encryption Type :</h4>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <FormControlLabel
                            vertical-align="middle"
                            value={true}
                            control={<Radio />}
                            label="Encrypt"
                          />
                          <FormControlLabel
                            vertical-align="middle"
                            value={false}
                            control={<Radio />}
                            label="Decrypt"
                          />
                        </Grid>
                      </Controls.RadioButton>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      {text && (
                        <>
                          <h4>
                            {type === ENCRYPTIONTYPE.ENCRYPT
                              ? "Encrypted Text :  "
                              : "Decrypted Text :  "}
                          </h4>
                          <h4>{text}</h4>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Grid item xs={12} md={2} className="marginAuto">
                        <Controls.Button>Submit</Controls.Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </div>
        </Container>
        <Container maxWidth="md" className="formClwidth">
          <div>
            <Formik
              enableReinitialize
              initialValues={{ ...INITIAL_FORM_STATE_HASH }}
              validationSchema={FORM_VALIDATION_HASH}
              onSubmit={(values) => submit(values, ENCRYPTIONTYPE.HASH)}
            >
              {() => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <h4> Hashing : </h4>
                      <Controls.Textfield
                        name="textToHash"
                        label="Text To Hash"
                        type="string"
                        placeholder="Text To Hash"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      {hashedText && (
                        <>
                          <h4>{"Hashed Text  :  "}</h4>
                          <h4>{hashedText}</h4>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Grid item xs={12} md={2} className="marginAuto">
                        <Controls.Button>Submit</Controls.Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>

            {alert?.counter > 0 && (
              <CustomizedSnackbars
                status={alert?.counter}
                msg={alert?.msg}
                type={alert?.type}
              />
            )}
          </div>
        </Container>
      </Grid>
    </>
  );
};

export default Encryption;
